<template>
  <VCard class="IntegrationCard">
    <VCardTitle>
      <component
        :is="logoHref ? 'a' : 'span'"
        :href="logoHref"
        target="_blank"
        class="logo-wrapper"
      >
        <VImg
          :alt="logoAlt"
          :src="logoSrc"
          :max-width="logoMaxWidth"
          :height="logoHeight"
          :contain="logoContain"
        />
      </component>
    </VCardTitle>
    <VCardText v-if="loading">
      <VSkeletonLoader
        type="paragraph"
      />
    </VCardText>
    <template v-else>
      <VCardText
        class="text-center"
        v-text="
          integration
            ? (integration.active ? syncText : inactiveText)
            : noSyncText
        "
      />
      <VCardText
        v-if="!pendingHealthCheck && healthCheckResult"
        class="text-center"
      >
        <strong>Статус интеграции: </strong>
        <span
          :class="{
            'green--text text--darken-4': healthCheckResult.isOk,
            'red--text text--darken-4': !healthCheckResult.isOk,
          }"
        >
          {{ healthCheckResult.healthCheck }}
        </span>
      </VCardText>
      <VCardActions
        v-if="integration && integration.active"
        class="justify-end"
      >
        <VBtn
          block
          :loading="pendingHealthCheck"
          :disabled="pendingHealthCheck"
          @click="healthCheck()"
        >
          <VIcon left>
            mdi-refresh
          </VIcon> Проверить
        </VBtn>
      </VCardActions>
    </template>
  </VCard>
</template>

<script>
export default {
  name: 'IntegrationCard',
  props: {
    code: { type: String, required: true }, // e.g.: 'bitrix24'
    logoSrc: { type: String, required: true },
    logoAlt: { type: String, required: true },
    logoMaxWidth: { type: String, default: '300px' },
    logoHeight: { type: String, default: '50px' },
    logoHref: { type: String, default: null },
    logoContain: { type: Boolean, default: false },
    syncText: { type: String, default: 'Интеграция настроена' },
    inactiveText: { type: String, default: 'Интеграция выключенна пользователем' },
    noSyncText: { type: String, default: 'Интеграция не настроена' },
  },
  data() {
    return {
      pendingHealthCheck: false,
    }
  },
  computed: {
    allIntegrations() { return this.$store.state.integration.map },
    loading() { return this.allIntegrations === null },
    integration() {
      const { allIntegrations: map, code } = this
      return (map && map[code]) || null
    },
    healthCheckResults() { return this.$store.state.integration.healthChecks },
    healthCheckResult() {
      const { healthCheckResults: map, code } = this
      return map[code] || null
    },
  },
  methods: {
    healthCheck() {
      const { code } = this
      this.pendingHealthCheck = true
      this.$store.dispatch('integration/healthCheck', { code })
        .finally(() => { this.pendingHealthCheck = false })
        .catch(e => console.error(e))
    },
  },
}
</script>

<style lang="sass" scoped>
  .logo-wrapper
    margin: 0 auto
</style>
